import styled from 'styled-components'
import { Alert, Card, OrderedList, Table, UnorderedList, Text, Link, Tooltip } from '@amzn/storm-ui'

export const AlertContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.large};
  display: flex;
  justify-content: center;
`
export const StyledAlert = styled(Alert)`
  width: 49%;
`
export const StyledCard = styled(Card)`
  width: 50%;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.spacing.small};
`
export const StyledTable = styled(Table)`
  width: 100% !important;
`
export const TableHeader = styled.th`
  font-weight: 700 !important;
`
export const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray[150]};
`
export const TableCell = styled.td`
  padding-bottom: ${({ theme }) => theme.spacing.medium} !important;
  vertical-align: top !important;
`
export const DescriptionList = styled(OrderedList)`
  margin-top: ${({ theme }) => theme.spacing.medium};
`
export const DropArea = styled.div`
  margin: ${({ theme }) => theme.spacing.medium} 0;
  > span {
    display: block;
    width: auto;
  }
`
export const FileUploadDescriptionList = styled(UnorderedList)`
  margin-top: 0;
  margin-inline-start: ${({ theme }) => theme.spacing.medium};
`
export const EmptySubmissionHistory = styled.td`
  padding: ${({ theme }) => theme.spacing.large};
`
export const EmptySubmissionHistoryText = styled(Text)`
  font-size: ${({ theme }) => theme.typography.size.medium};
  font-weight: bold;
  color: ${({ theme }) => theme.palette.boulder};
  text-align: center;
`
export const BillingInfoTextElement = styled(Text)`
  display: flex;
  justify-content: flex-start;
`
export const BillingInfoLabel = styled(Text)`
  width: 100px;
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
`
export const BoxElement = styled.div`
  display: flex;
  justify-content: space-between;
`
export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
export const CardHeaderSubheader = styled(Text)`
  color: ${({ theme }) => theme.palette.boulder};
`
export const TermConditionText = styled(Text)`
  margin-top: ${({ theme }) => theme.spacing.large}!important;
`
export const ChangeFileLink = styled(Link)`
  margin-inline-start: ${({ theme }) => theme.spacing.micro}!important;
  cursor: pointer;
`
export const StyledSpinner = styled.div`
  display: inline;
  opacity: 0.8;
`
export const StyledSuccessIcon = styled.div`
  display: inline;
  ${({ theme }) => 'color: ' + theme.palette.auigreen + ';'}
`
export const StyledErrorIcon = styled.div`
  display: inline;
  ${({ theme }) => 'color: ' + theme.palette.red[600] + ';'}
  margin-inline-start: ${({ theme }) => theme.spacing.micro};
  margin-inline-end: ${({ theme }) => theme.spacing.micro};
`
export const StyledWarningIcon = styled.div`
  display: inline;
  ${({ theme }) => 'color: ' + theme.palette.clementine[700] + ';'}
`
export const StatusCell = styled.div`
  display: inline-flex;
`
export const StatusIcon = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.micro};
`
export const StatusDescription = styled(Text)`
  display: inline;
`

interface ReportDownloadLinkProps {
  downloadURlLoading: boolean
}

export const ReportDownloadLink = styled.div<ReportDownloadLinkProps>`
  cursor: ${({ downloadURlLoading }) => (downloadURlLoading ? 'wait' : 'pointer')};
  color: ${({ theme }) => theme.palette.blue[700]};
  :hover {
    text-decoration: underline;
  }
`

export const BlockTooltip = styled(Tooltip)`
  display: block;
`
